import script from "./AcceptedStudioView.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptedStudioView.vue?vue&type=script&setup=true&lang=js"

import "./AcceptedStudioView.vue?vue&type=style&index=0&id=3d84d528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d84d528"]])

export default __exports__